import { StatusBadge, UserAvatarBlock } from "components/core";
import { PREMIUM_SERVICE_INTEREST_STATUS_BADGE_OPTIONS } from "components/forms/premium-service-interest/schema";
import lodash from "lodash";
import moment from "moment";
import { FC } from "react";

export interface PremiumServiceInterestViewProps {
  premiumServiceInterest: any
}

export const PremiumServiceInterestView: FC<PremiumServiceInterestViewProps> = ({
  premiumServiceInterest: item,
}) => {
  return (
    <div className="space-y-6 divide-y divide-gray-200">
      <div className="grid grid-cols-2 gap-6">
        <div>
          <p className="text-xs font-light text-gray-500">Code</p>
          <p className="mt-1 text-sm font-medium text-gray-900 dark:text-gray-100">
            {item.code || "N/A"}
          </p>
        </div>
        <div>
          <p className="text-xs font-light text-gray-500">Status</p>
          <div className="mt-1">
            <StatusBadge
              status={item.status || ""}
              options={PREMIUM_SERVICE_INTEREST_STATUS_BADGE_OPTIONS}
            />
          </div>
        </div>
        <div className="col-span-2">
          <p className="text-xs font-light text-gray-500">Origin</p>
          <p className="mt-1 text-sm font-medium text-gray-900 dark:text-gray-100">
            {lodash.startCase(item.origin) || "N/A"}
          </p>
        </div>
        <div>
          <p className="text-xs font-light text-gray-500">Region</p>
          <p className="mt-1 text-sm text-gray-900 dark:text-gray-100">
            {item.region
              ? `${item.region.name}`
              : "N/A"}
          </p>
        </div>
        <div>
          <p className="text-xs font-light text-gray-500">District</p>
          <p className="mt-1 text-sm text-gray-900 dark:text-gray-100">
            {item.district
              ? `${item.district.name}`
              : "N/A"}
          </p>
        </div>
      </div>

      <div className="pt-6">
        <p className="text-xs font-light text-gray-500">Customer Details</p>
        <div className="grid grid-cols-2 gap-6 mt-2">
          <div>
            <p className="text-xs text-gray-500">Full Name</p>
            <p className="mt-1 text-sm text-gray-900 dark:text-gray-100">
              {item.customer?.fullName || "N/A"}
            </p>
          </div>
          <div>
            <p className="text-xs text-gray-500">Phone Number</p>
            <p className="mt-1 text-sm text-gray-900 dark:text-gray-100">
              {item.customer?.phoneNumber || "N/A"}
            </p>
          </div>
          <div className="col-span-2">
            <p className="text-xs text-gray-500">Digital Address</p>
            <p className="mt-1 text-sm text-gray-900 dark:text-gray-100">
              {item.customer?.digitalAddress || "N/A"}
            </p>
          </div>
        </div>
      </div>

      {item.status === "Cancelled" && (
        <div className="pt-6 grid grid-cols-2 gap-6">
          <UserAvatarBlock user={item.cancelledBy} label="Cancelled By" />
          <div>
            <p className="text-xs font-light text-gray-500">Cancelled At</p>
            <p className="mt-1 text-sm text-gray-900 dark:text-gray-100">
              {item.cancelledAt
                ? moment(item.cancelledAt).format("DD/MM/YYYY [at] hh:mm A")
                : "N/A"}
            </p>
          </div>
          <div className="col-span-2">
            <p className="text-xs font-light text-gray-500">
              Cancellation Reason
            </p>
            <p className="mt-1 text-sm text-gray-900 dark:text-gray-100 whitespace-pre-wrap">
              {item.cancellationReason || "N/A"}
            </p>
          </div>
        </div>
      )}

      {item.status === "AppointmentConfirmed" && (
        <div className="pt-6 my-2 grid grid-cols-3 gap-6 border-2 bg-gray-50 border-gray-200 rounded-md p-6 border-dashed">
          <div>
            <p className="text-xs font-light text-gray-500">Appointment Code</p>
            <p className="mt-1 text-sm text-gray-900 dark:text-gray-100">
              {item.appointment?.code || "N/A"}
            </p>
          </div>
          <div className="">
            <p className="text-xs font-light text-gray-500">
              Appointment Confirmed At
            </p>
            <p className="mt-1 text-sm text-gray-900 dark:text-gray-100">
              {item.appointmentConfirmedAt
                ? moment(item.appointmentConfirmedAt).format(
                    "DD/MM/YYYY [at] hh:mm A",
                  )
                : "N/A"}
            </p>
          </div>
          <UserAvatarBlock user={item.appointmentConfirmedBy} label="Confirmed By" />
          <div className="">
            <p className="text-xs font-light text-gray-500">
              Status
            </p>
            <p className="mt-1 text-sm text-gray-900 dark:text-gray-100">
              {lodash.startCase(item.appointment?.status) || "N/A"}
            </p>
          </div>
          <div className="">
            <p className="text-xs font-light text-gray-500">
              Appointment Date & Time
            </p>
            <p className="mt-1 text-sm text-gray-900 dark:text-gray-100">
              {item.appointment?.estimatedResolutionDate
                ? moment(item.appointment?.estimatedResolutionDate).format(
                  "DD/MM/YYYY [at] hh:mm A",
                )
                : "N/A"}
            </p>
          </div> 
          <UserAvatarBlock user={item.appointment?.assignee} label="CEWP Personnel" />
        </div>
      )}

      <div className="pt-6 grid grid-cols-2 gap-6">
        {item.createdBy && (
          <UserAvatarBlock user={item.createdBy} label="Created By" />
        )}
        <div>
          <p className="text-xs font-light text-gray-500">Date Created</p>
          <p className="mt-1 text-sm text-gray-900 dark:text-gray-100">
            {item.createdAt
              ? moment(item.createdAt).format("DD/MM/YYYY [at] hh:mm A")
              : "N/A"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PremiumServiceInterestView;
